module.exports = __webpack_public_path__ + "img/cropped-kitkit-phase3_icon-270x270.4778fca8.png";